export const vpneStyles = {
	background: {
		default: '#eae8e8',
		paper: '#ffffff',
	},
	primaryColor: '#15ADDF',
	header: {
		backgroundColor: '#eae8e8',
		color: '#262626',
	},
	sidebar: {
		backgroundColor: '#262626',
		color: 'white',
	},
	button: {
		backgroundColor: '#15ADDF',
		color: '#262626',
		border: '1px solid #262626',
		fontWeight: 600,
		':hover': {
			color: '#ffffff',
			backgroundColor: '#262626',
		},
	},
	title: {
		color: '#262626',
	},
	text: {
		color: '#262626',
	},
	table: {
		headerBackgroundColor: '#262626',
		headerTextColor: '#ffffff',
	},
	tab: {
		backgroundColor: '#15ADDF',
		color: '#262626',
	},
	dataGrid: {
		backgroundColor: '#ffffff',
		borderColor: '#c9c7c7',
		'& .MuiDataGrid-columnHeaders': {
			backgroundColor: '#262626',
			color: '#ffffff',
			borderBottom: 'none',
		},
		'& .MuiDataGrid-columnHeader': {
			backgroundColor: '#262626',
		},
		'& .MuiDataGrid-columnSeparator, & .MuiDataGrid-sortIcon, & .MuiDataGrid-menuIconButton': {
			color: '#ffffff !important',
		},
		'& .MuiDataGrid-row:hover': {
			backgroundColor: 'rgba(21, 173, 223, 0.08)',
		},
		'& .MuiDataGrid-cell a': {
			color: '#262626',
			textDecoration: 'underline',
			textDecorationColor: '#15ADDF',
			textDecorationThickness: '2px',
			textUnderlineOffset: '2px',
		},
	},
	dataGridToolbar: {
		backgroundColor: '#eae8e8',
		borderBottom: '1px solid #c9c7c7',
	},
	paper: {
		backgroundColor: '#ffffff',
		border: '1px solid #c9c7c7',
	},
	platformName: {
		name: 'VPNE Parking Platform',
	},
	logo: {
		small: {
			src: '/vpne/vpne-logo-white.svg',
			height: 45,
			width: 45,
		},
		large: {
			src: '/vpne/vpne-logo-white.svg',
			height: 45,
			width: 125,
		},
	},
	monthlyCheckoutLogo: {
		small: {
			src: '/vpne/vpne-logo-black.svg',
			height: 45,
			width: 45,
		},
		large: {
			src: '/vpne/vpne-logo-black.svg',
			height: 45,
			width: 125,
		},
	},
	favicon: {
		src: '/vpne/favicon-196x196.png',
		type: 'image/png',
		sizes: '196x196',
	},
	socials: {
		instagram: 'https://www.instagram.com/vpneparking',
		facebook: 'https://www.facebook.com/VPNEParkingSolutions/',
		linkedIn: 'https://www.linkedin.com/company/vpne/',
	},
	siteUrl: 'https://vpne.com/',
	orgName: 'VPNE Parking',
};
